export default function FinalMessage() {
    return (
        <section
            data-testid="final-message"
            className="px-6 sm:px-8 py-20 sm:py-24 bg-[#fbf8f5]"
        >
            <div className="max-w-3xl mx-auto text-center">
                <span className="sprig">
                    <span className="eyebrow" style={{ color: "var(--color-sage-deep)" }}>
                        Nuestro compromiso
                    </span>
                </span>
                <p className="headline mt-7 text-2xl sm:text-3xl leading-snug text-[#2d2a28]">
                    “Matrona IA nace para acompañar, informar y orientar.
                    <br className="hidden sm:block" />
                    <em className="italic text-[#b7677a]">
                        Nunca para sustituir el cuidado humano,
                    </em>{" "}
                    la relación clínica ni la autonomía de cada mujer.”
                </p>
            </div>
        </section>
    );
}
